import React from "react";
import {UnderlinedHeader} from "../../../components";
import './_tags-tooltip-content.scss';


export const TagsTooltipContent: React.FC = () => {
    return (
        <>
            <div data-testid={"tags-selection-message"} className="tags-selection textalign-left">
                <b>Exempt</b> and <b>Non-Exempt</b> will display the corresponding tag on the trust within the
                flowchart visual. <br/><br/>
                Selecting <b>Both</b> will display both tags directly on the trust within the flowchart
                visual. <br/><br/>
                If the status is <b>unknown,</b> you may select unknown. No tags will be displayed on the trust
                within the visual.<br/>
            </div>
            <div className="tags-info-instance">
                <UnderlinedHeader className={"both-tag-header"} leftAlignedContent={<span>Both Tag Example</span>}/>
                <div className="descendent-trust-container">
                    <img data-testid={"descendent-trust"} alt={"Descendent Trust"}
                         src={"/descendentTrust_bothCard.png"}/>
                </div>
            </div>
        </>
    );
}